import { TimelineMax, TweenMax, Expo } from 'gsap'
import SplitText from '@/assets/lib/SplitText'
import EventBus from '@/scripts/event-bus'

const transition = (firstEnter, callback) => {
  if (firstEnter) {
    TweenMax.set('[data-header]', { autoAlpha: 0 })
    TweenMax.set('[data-scroll]', { autoAlpha: 0 })
    TweenMax.set('[data-hero-image]', { autoAlpha: 0 })
    TweenMax.set('[data-arrows-hero]', { autoAlpha: 0 })
  }

  const split = new SplitText(
    document.querySelector('[data-title]'),
    { type: 'words, chars', charsClass: 'title-chars' }
  )
  const tl = new TimelineMax({
    delay: 0.5,
    onComplete: () => {
      callback();
    },
  })

  tl
    .add('start')
    .set('#smoothie', {
      autoAlpha: 1,
      y: 0
    }, 'start')
    .add(() => {
      let anim = []
      if (firstEnter) {
        EventBus.$emit('triggerRandomLight')

        anim = TweenMax.fromTo('[data-header]', 1.4, {
          yPercent: -100,
          autoAlpha: 0
        }, {
          yPercent: 0,
          autoAlpha: 1,
          ease: Expo.easeInOut,
          clearProps: 'all',
        })
      } else {
        anim = TweenMax.fromTo('[data-hero-image]', 0.8, {
          autoAlpha: 0,
          scale: 1.2
        }, {
          autoAlpha: 1,
          scale: 1,
          ease: Expo.easeInOut
        }, 'start')
      }

      return anim
    }, 'start')
    .add(() => {
      let anim = []
      if (firstEnter) {
        anim = TweenMax.fromTo('[data-scroll]', 1.4, {
          autoAlpha: 0
        }, {
          autoAlpha: 1,
          ease: Expo.easeInOut
        })
      }

      return anim
    }, 'start')
    .staggerFromTo(split.chars, 1.2, {
      yPercent: 60,
      rotationZ: 20,
      rotationY: 80,
      autoAlpha: 0
    }, {
      yPercent: 0,
      rotationZ: 0,
      rotationY: 0,
      autoAlpha: 1,
      ease: Expo.easeInOut
    }, 0.03, 'start')
    .fromTo('[data-arrows-hero]', 1, {
      y: 20,
      autoAlpha: 0
    }, {
      y: 0,
      autoAlpha: 1,
      ease: Expo.easeInOut
    }, 'start+=0.6')

  return tl
}

export default transition



// WEBPACK FOOTER //
// ./src/scripts/transitions/sliderEnter.js